export default {
    tablequery: {
        getChooseOrderData: '/basic/ppm/order', // 获取查询表格信息---订单信息
        getChooseOrderSnapshotData: '/basic/ppm/orderSnapshot', // 获取查询表格信息---订单信息
        getChooseBuyerData: '/basic/ppm/buyer', //采购商
        getDept: '/basic/ppm/dept', //预算单位
        getChooseSupplierDataOut: '/basic/ppm/supplierOut', //供应商（对外）
        getChooseSupplierData: '/basic/ppm/supplier', //供应商管理（对内）
        getChooseGoodsData: '/basic/ppm/goods', //商品
        getPortfolioGoodsData: '/basic/ppm/portfolioGoods', //组合商品
        getChooseLadderData: '/basic/ppm/ladder', //商品阶梯价
        getChooseLogisticsData: '/basic/ppm/logistics', //物流
        getChooseComplainData: '/basic/ppm/complain', //投诉
        getChooseTobSupplierMustBeTriedAudit: '/basic/ppm/tobSupplierMustBeTriedAudit', //供应商必审审核记录宽表
        getChooseTobSupplierMayBeTriedAudit: '/basic/ppm/tobSupplierMayBeTriedAudit', //供应商必审审核记录宽表
        getUnionOrders: '/basic/ppm/orderLabor', //工会2.0订单
        getLabourOrders3: '/basic/ppm/labourOrders3', //工会3.0订单
        getExcellentOrders: '/basic/ppm/excellentOrders', //832优选（食堂）订单
        getSelectData: '/basic/ppm/getClounm', //获取下拉框的数据
        goExportFile: '' //导出表格按钮
    },
    tablequerytoC: {
        getChooseOrderData: '/basic/mpp/order', // 获取查询表格信息---订单信息
        getChooseGoodsOrderItemData: '/basic/mpp/goodsOrderItem', //商品订单明细
        getChooseBuyerData: '/basic/mpp/buyer', //个人用户
        getChooseSupplierData: '/basic/mpp/supplier', //卖家
        getChooseGoodsData: '/basic/mpp/goods', //商品
        getChooseLadderData: '/basic/mpp/ladder', //商品阶梯价
        getChooseLogisticsData: '/basic/mpp/logistics', //物流
        getChooseComplainData: '/basic/mpp/complain', //投诉
        activity: '/basic/mpp/activity', //活动
        getSelectData: '/basic/mpp/getClounm', //获取下拉框的数据
        goExportFile: '' //导出表格按钮
    },
    // tableQueryModel: {
    //     add: '/basic/mpp/mould',
    //     edit: '/basic/mpp/updateMould',
    //     search: '/basic/mpp/getAll',
    //     delete: '/basic/mpp/deleteMould'
    // },
    tableQueryModel: {
        add: '/basic/resourcePermission2/addMould',
        edit: '/basic/resourcePermission2/updateMould',
        search: '/basic/resourcePermission2/listResources',
        delete: '/basic/resourcePermission2/deleteResource',
        addUserResource: '/basic/userResource2/addUserResource', //添加用户资源权限,resourceId,ids
        deleteUserResource: '/basic/userResource2/deleteUserResource', //删除用户资源信息,userId,id
        getResourceUser: '/basic/userResource2/getResourceUser', //获取资源相关用户,id,flag
        getUserResource: '/basic/userResource2/getUserResource', //获取用户资源,type
        getDataSnapshotDate: '/basic/ppm/snapshot', //获取数据快照日期
        getCreateSnapshot: '/basic/ppm/createSnapshot'
    },
    tablequeryNew: {
        // 运营新增宽表
        settledSupplier: '/basic/run/settledSupplier', //  入驻供应商数
        activeSupplier: '/basic/run/activeSupplier', //  活跃供应商数
        goods: '/basic/run/goods', //  入驻供应商数
        supplierSettledCoverage: '/basic/run/supplierSettledCoverage', //    入驻供应商覆盖县域
        supplierActiveCoverage: '/basic/run/supplierActiveCoverage', //  活跃供应商覆盖县域
        weight: '/basic/run/weight', //  重量统计
        buyerTurnover: '/basic/run/buyerTurnover', // 采购人维度交易汇总额

        getClounm: '/basic/run/getClounm', //  活跃供应商数下拉框
        dealSeller: '/basic/run/dealSeller', //交易供应商数
        dealBuyer: '/basic/run/dealBuyer', //交易采购人数
        goExportFile: '' //导出表格按钮
    },
    goTarget: {
        //导出表格按钮跳转接口
        supplierOutCopy: '/basic/ppm/supplierOutCopy', //供应商(对外)
        supplierCopy: '/basic/ppm/supplierCopy', //供应商管理(对内)
        buyerCopy: '/basic/ppm/buyerCopy', //采购商
        deptCopy: '/basic/ppm/deptCopy', //预算单位
        goodsCopy: '/basic/ppm/goodsCopy', //商品
        portfolioGoodsCopy: '/basic/ppm/portfolioGoodsCopy', //组合商品
        ladderCopy: '/basic/ppm/ladderCopy', //商品阶梯价
        orderCopy: '/basic/ppm/orderCopy', //订单
        orderSnapshotCopy: '/basic/ppm/orderSnapshotCopy', //订单快照
        complainCopy: '/basic/ppm/complainCopy', //投诉
        logisticsCopy: '/basic/ppm/logisticsCopy', //物流
        supplierMustBeTriedCopy: '/basic/ppm/supplierMustBeTriedCopy', //zy add for 供应商必审审核记录
        supplierMayBeTriedCopy: '/basic/ppm/supplierMayBeTriedCopy', //zy add for 供应商选审审核记录
        unionOrdersCopy: '/basic/ppm/orderLaborCopy', //工会V2.0
        labourOrders3Copy: '/basic/ppm/labourOrders3Copy', //工会V3.0
        excellentOrdersCopy: '/basic/ppm/excellentOrdersCopy' //832优选（食堂）订单
    },
    goTargettoC: {
        //导出表格按钮跳转接口
        orderCopy: '/basic/mpp/orderCopy', //订单
        goodsOrderItemCopy: '/basic/mpp/goodsOrderItemCopy', //商品订单明细
        supplierCopy: '/basic/mpp/supplierCopy', //卖家
        buyerCopy: '/basic/mpp/buyerCopy', // 个人用户
        goodsCopy: '/basic/mpp/goodsCopy', //商品
        logisticsCopy: '/basic/mpp/logisticsCopy', //物流
        ladderCopy: '/basic/mpp/ladderCopy', // 阶梯价
        complainCopy: '/basic/mpp/complainCopy', //投诉
        activityCopy: '/basic/mpp/activityCopy' //活动
    },
    goTargetNew: {
        //运营新增导出表格按钮跳转接口
        settledSupplierCopy: '/basic/run/settledSupplierCopy', //  入驻供应商数
        activeSupplierCopy: '/basic/run/activeSupplierCopy', //  活跃供应商数
        goodsCopy: '/basic/run/goodsCopy', //  入驻供应商数
        supplierSettledCoverageCopy: '/basic/run/supplierSettledCoverageCopy', //  入驻供应商覆盖县域
        supplierActiveCoverageCopy: '/basic/run/supplierActiveCoverageCopy', //  活跃供应商覆盖县域
        weightCopy: '/basic/run/weightCopy', //  入驻供应商数
        complain: '/basic/run/complainCopy', // 运营新增
        buyerTurnoverCopy: '/basic/run/buyerTurnoverCopy', // 运营新增
        dealSellerCopy: '/basic/run/dealSellerCopy', // 交易供应商数导出
        dealBuyerCopy: '/basic/run/dealBuyerCopy' // 交易采购人数导出
    },
    level: {
        //层级查询
        city: '/basic/ppm/queryRegion', //省，市，县
        queryClass: '/basic/ppm/queryClass', // 品类
        queryDept: '/basic/ppm/queryDept' // 预算单位层级
    },
    leveltoC: {
        //层级查询
        city: '/basic/mpp/queryRegion', //省，市，县
        queryClass: '/basic/mpp/queryClass', // 品类
        queryDept: '/basic/ppm/queryDept' // 预算单位层级
    },
    exportFileManagement: {
        getTableData: '/basic/ppm/gpFileList', //获取表格数据  get
        downloadFile: '/basic/ppm/download' //下载文件
    }
};
